import { UserListPage } from "newui/features/Auth/components/User/UserListPage";

interface AccountUsersRouteProps {
	// reach-router injects `path` when this is used as a <Router> child; unused here.
	path?: string;
}

/**
 * FF-W3-6: single mount point for account-settings/users.
 *
 * RBAC v2 is ADDITIVE — it must never remove the existing user-management surface
 * (search, invite, status filters, activate/deactivate/resend, the guided help
 * tour). `UserListPage` is therefore the single base for BOTH flag states; it
 * detects `useHasRbacV2()` internally and layers RBAC role management (role
 * pills, per-user "Manage roles" modal, bulk "Allocate Roles" picker + Add
 * flow) on top when the flag is on. See PRO-413 §7 — the cutover previously
 * swapped the whole page for the bare assignment table, silently dropping all
 * legacy functionality.
 */
export const AccountUsersRoute = ({ path: _path }: AccountUsersRouteProps) => (
	<UserListPage />
);
